import AddressFieldPreview from "./MobilePreviewItems/AddressFieldPreview";
import CheckboxFieldPreview from "./MobilePreviewItems/CheckboxFieldPreview";
import DatePreview from "./MobilePreviewItems/DatePreview";
import DropdownPreview from "./MobilePreviewItems/DropdownPreview";
import NumberFieldPreview from "./MobilePreviewItems/NumberFieldPreview";
import RadioFieldPreview from "./MobilePreviewItems/RadioFieldPreview";
import SliderPreview from "./MobilePreviewItems/SliderPreview";
import TextFieldPreview from "./MobilePreviewItems/TextFieldPreview";
import UploadFilePreview from "./MobilePreviewItems/UploadFilePreview";

export const MobilePreviewcomponentMap: Record<string, any> = {
  slider: SliderPreview,
  upload_file: UploadFilePreview,
  radio: RadioFieldPreview,
  checkbox: CheckboxFieldPreview,
  dropdown: DropdownPreview,
  text: TextFieldPreview,
  date: DatePreview,
  number: NumberFieldPreview,
  calculated_field: NumberFieldPreview,
  address: AddressFieldPreview,
};
